(function () {

    let currentApp = angular.element($('[ng-app]')).attr('ng-app');
    let app = angular.module(currentApp);

    let CampaignController = function () {
        let self = this;

        self.campaign = {};
        self.campaign.started_at = undefined;
        self.campaign.ended_at = undefined;
        self.myDate = new Date();
		self.myStartDate = new Date();
		self.myStartDateHour = 0;
		self.myStartDateMinute = 0;
		self.myEndDate = new Date();
		self.myEndDateHour = 23;
		self.myEndDateMinute = 59;
		self.hours = range(0, 23);
		self.minutes = range(0, 59);

        self.dateChange = function () {
        	if(self.myStartDate !== undefined) {
	            self.campaign.started_at = new Date(
	            	self.myStartDate.getFullYear(),
					self.myStartDate.getMonth(),
					self.myStartDate.getDate(),
					self.myStartDateHour,
					self.myStartDateMinute,
					0
				);
            }

            if(self.myEndDate !== undefined) {
				self.campaign.ended_at = new Date(
					self.myEndDate.getFullYear(),
					self.myEndDate.getMonth(),
					self.myEndDate.getDate(),
					self.myEndDateHour,
					self.myEndDateMinute,
					0
				);
            }
        };

        self.init = function (start, end) {
        	if (start !== '' && start !== undefined) {
	        	// let startPieces = start.split(/[- :T]/);
				// self.myStartDate = new Date(
				// 	startPieces[0],
				// 	startPieces[1] - 1,
				// 	startPieces[2],
				// 	startPieces[3],
				// 	startPieces[4],
				// 	0
				// );
				self.myStartDate = new Date(start);
				self.myStartDateHour = self.myStartDate.getHours();
				self.myStartDateMinute = self.myStartDate.getMinutes();
				self.campaign.started_at = self.myStartDate;
        	}

        	if (end !== '' && end !== undefined) {
	        	// let endPieces = end.split(/[- :T]/);
				// self.myEndDate = new Date(
				// 	endPieces[0],
				// 	endPieces[1] - 1,
				// 	endPieces[2],
				// 	23,
				// 	59,
				// 	59
				// );
				self.myEndDate = new Date(end);
				self.myEndDateHour = self.myEndDate.getHours();
				self.myEndDateMinute = self.myEndDate.getMinutes();
				self.campaign.ended_at = self.myEndDate;
			}
        };
    };

    angular.module('TetherApp').controller('CampaignController', [
        CampaignController
    ]);

}());
